// extracted by mini-css-extract-plugin
module.exports = {"main":"Point_main__39zlJ"};